import cn from 'classnames'
import React from 'react'

import { splitProps } from '@/utils/collections'

import FormField, { FormlessFormField } from '../FormField'
import Text, { TextProps } from '../Input/Text/Text'
import { FormFieldProps } from '../types'

/**
 * Form field with text input.
 */
export default class TextFormField extends React.PureComponent<
	Omit<TextProps, 'onChange'> & FormFieldProps & { formless?: boolean }
> {
	render() {
		const fieldProps = { ...this.props }

		const inputProps = splitProps(fieldProps, [
			'placeholder',
			'type',
			'autoFocus',
			'enableAutocomplete',
			'formatter',
			'titleContainer',
			'isRequired',
			'refInput',
			'testId',
		])
		const className = cn(`w-full ${fieldProps.className}`)

		const FF = this.props.formless ? FormlessFormField : FormField

		return (
			<FF {...fieldProps}>
				<Text className={className} {...inputProps} />
			</FF>
		)
	}
}
